import Image from 'next/image';
import { FaTwitter, FaGithub } from 'react-icons/fa';
import countries from 'i18n-iso-countries';
import ReactCountryFlag from 'react-country-flag';

countries.registerLocale(require('i18n-iso-countries/langs/en.json'));

export default function ShowcaseCard({
  externalUrl,
  coverImage,
  description,
  title,
  tags,
  authors,
}) {
  const { name, country, twitterHandle, gitHub, photo } = authors[0];

  const upperCountryCode = country.toUpperCase();
  const countryName = countries.getName(upperCountryCode, 'en', {
    select: 'alias',
  });

  return (
    <div className="flex flex-col justify-between">
      <a href={externalUrl} target="_blank" rel="noopener noreferrer">
        <div className="shadow-elevation border flex border-bunting-dark rounded-lg relative">
          <Image
            src={coverImage?.url || '/images/showcase/placeholder.png'}
            width={744}
            height={548}
            alt={coverImage?.alt || `${title} cover image`}
            className="rounded-lg"
            objectFit="cover"
          />
        </div>
        <p className="font-bold text-white text-xl leading-6 mt-6 mb-2">
          {title}
        </p>
        <div className="space-x-3 flex items-center flex-wrap">
          {tags.map((tag) => (
            <span
              className="bg-zodiac rounded text-xs py-1 px-2 font-medium text-whisper"
              key={tag}
            >
              {tag}
            </span>
          ))}
        </div>
        <p className="text-rock-blue mt-6">{description}</p>
      </a>

      <div className="flex items-center justify-between mt-6">
        <div className="flex items-center">
          <Image
            src={photo.url}
            width={40}
            height={40}
            alt={`${name} photo`}
            className="rounded-full object-contain"
          />

          <div className="text-sm leading-5 ml-3">
            <p className="text-white font-medium">{name}</p>
            <p className="text-rock-blue flex items-center">
              <ReactCountryFlag
                className="w-4 leading-3 mr-1 rounded-[3px]"
                svg
                countryCode={upperCountryCode}
                aria-label={`${countryName} flag`}
              />

              {countryName}
            </p>
          </div>
        </div>

        {(twitterHandle || gitHub) && (
          <div className="flex items-center space-x-3 text-rock-blue">
            {gitHub && (
              <a
                href={gitHub}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition-colors"
              >
                <FaGithub className="w-5 h-5" />
              </a>
            )}
            {twitterHandle && (
              <a
                href={`https://twitter.com/${twitterHandle}`}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition-colors"
              >
                <FaTwitter className="w-5 h-5" />
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
